import { Box, Chip, Typography } from '@mui/material';
import { formatCurrency, getDisplayPrice } from '../../utils/priceUtils';

export const getColumns = (isMobile) => {
  const baseColumns = [
    {
      field: 'thumbnailImage',
      headerName: '',
      width: isMobile ? 60 : 80,
      sortable: false,
      renderCell: (params) => (
        <img 
          src={params.value} 
          alt={params.row.name}
          style={{ 
            width: isMobile ? 50 : 60, 
            height: isMobile ? 50 : 60, 
            objectFit: 'contain' 
          }}
        />
      )
    },
    {
      field: 'name',
      headerName: 'Name',
      flex: isMobile ? 1 : 3,
      minWidth: isMobile ? 120 : 300,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
          <Typography
            variant="body2"
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {params.value}
          </Typography>
          {params.row.productCategory && (
            <Chip
              size="small"
              label={params.row.productCategory}
              sx={{
                height: 20,
                fontSize: '0.67rem',
                fontWeight: 700,
                bgcolor: params.row.productCategory === 'TCG' ? '#F97316' : '#E2E8F0',
                color: params.row.productCategory === 'TCG' ? '#fff' : '#0F172A'
              }}
            />
          )}
          {params.row.hasMcOffer && (
            <Chip
              size="small"
              label="MC"
              sx={{
                height: 20,
                fontSize: '0.67rem',
                fontWeight: 700,
                bgcolor: '#1976d2',
                color: '#fff'
              }}
            />
          )}
        </Box>
      )
    },
    {
      field: 'manufacturer',
      headerName: 'Brand',
      flex: 1,
      minWidth: 100,
    },
    {
      field: 'regularPrice',
      headerName: 'Price',
      width: isMobile ? 100 : undefined,
      flex: isMobile ? undefined : 1,
      minWidth: isMobile ? 100 : 100,
      renderCell: (params) => {
        const displayPrice = formatCurrency(getDisplayPrice(params.row));
        const regularPrice = formatCurrency(params.row.regularPrice);

        if (!params.row.onSale) {
          return displayPrice || '—';
        }

        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', lineHeight: 1.1 }}>
            <Typography sx={{ fontWeight: 700, fontSize: '0.84rem', color: 'var(--sm-success-strong)' }}>
              {displayPrice || '—'}
            </Typography>
            {regularPrice && (
              <Typography sx={{ fontSize: '0.74rem', color: 'text.secondary', textDecoration: 'line-through' }}>
                {regularPrice}
              </Typography>
            )}
          </Box>
        );
      }
    },
    {
      field: 'inStoreAvailability',
      headerName: 'In Store',
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <Chip 
          label={params.value ? "Available" : "Unavailable"}
          color={params.value ? "success" : "error"}
          size="small"
        />
      )
    },
    {
      field: 'onlineAvailability',
      headerName: 'Online',
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <Chip 
          label={params.value ? "Available" : "Unavailable"}
          color={params.value ? "success" : "error"}
          size="small"
        />
      )
    }
  ];

  return baseColumns;
};
